import { Component, OnInit, ViewChild, Input } from "@angular/core";
import { NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ObraDTO } from "src/app/models/dtos/obra-dto";
import { Obra } from "../../../../models/entities/obra";
import { ArchivosWebService } from "../../../../services/archivos-web.service";
import { ArchivoPDF } from "../../../../models/entities/archivoPdf";
import {
  PDFProgressData,
  PdfViewerComponent,
  PDFDocumentProxy,
  PDFSource,
} from "ng2-pdf-viewer";
import { LevantamientoSeleccionadoDTO } from "../../../../models/dtos/levantamiento-seleccionado-dto";
import { AngularFireStorage } from "@angular/fire/storage";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import * as FileSaver from "file-saver";

@Component({
  selector: "modal-pdf-ficha-tecnica",
  templateUrl: "./modal-pdf-ficha-tecnica.component.html",
  styleUrls: ["./modal-pdf-ficha-tecnica.component.scss"],
})
export class ModalPDFFichaTecnicaComponent implements OnInit {
  public obraSeleccionada: ObraDTO;
  public obraSeleccionada2: LevantamientoSeleccionadoDTO;
  public modalActivo: NgbModalRef;
  @ViewChild("modalPdfFichaTecnica")
  public modalPdfFichaTecnica: any;
  fichaPdf: ArchivoPDF;
  progressData: PDFProgressData;
  isLoaded = false;
  error: any;
  archivosPdf: ArchivoPDF[] = [];
  pdfUrl: Observable<string | null>;

  constructor(
    private modalService: NgbModal,
    private arhivosService: ArchivosWebService,
    private storage: AngularFireStorage,
    private http: HttpClient
  ) {}

  ngOnInit() {}

  public abrirModal(obra: ObraDTO) {
    this.obraSeleccionada = obra;
    // tslint:disable-next-line: max-line-length
    // tslint:disable-next-line: max-line-length
    this.arhivosService
      .getPdf(this.obraSeleccionada.obra.keyLevantamientoObra)
      .subscribe((data) => {
        this.fichaPdf = data[data.length - 1];
        this.archivosPdf = data;
      });
    this.modalActivo = this.modalService.open(this.modalPdfFichaTecnica, {
      centered: true,
      size: "lg",
      windowClass: "modal-ficha-tecnica",
    });
  }

  public abrirModalPersonalizado(obra: Obra): void {
    let datosObra: ObraDTO = new ObraDTO();
    datosObra.obra = obra;
    this.modalActivo = this.modalService.open(this.modalPdfFichaTecnica, {
      centered: true,
      size: "lg",
      windowClass: "modal-ficha-tecnica",
    });
  }

  public cerrarModal(): void {
    this.modalActivo.close();
  }

  onProgress(progressData: PDFProgressData) {
    // console.log(progressData);
    this.progressData = progressData;
    this.isLoaded = false;
    this.error = null; // clear error
  }
  getInt(value: number): number {
    return Math.round(value);
  }

  verArchivo(archivo: ArchivoPDF) {
    this.fichaPdf = archivo;
  }

  descargarPDF(url: string, nombre: string) {
    const pdfUrl = url;
    const pdfName = nombre;
    FileSaver.saveAs(pdfUrl, pdfName);
  }

  public abrirModalByKey(obra: any, nombre: string) {
    // console.log(obra, nombre);
    this.obraSeleccionada2 = obra;
    // tslint:disable-next-line: max-line-length
    // tslint:disable-next-line: max-line-length
    this.arhivosService
      .getPdf(this.obraSeleccionada2.levObra.key)
      .subscribe((data) => {
        this.fichaPdf = data.find((ficha) => ficha.nombre === nombre);
        this.archivosPdf = data;
      });
    this.modalActivo = this.modalService.open(this.modalPdfFichaTecnica, {
      centered: true,
      size: "lg",
      windowClass: "modal-ficha-tecnica",
    });
  }
}
